import script from "./PromotionsVue.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionsVue.vue?vue&type=script&setup=true&lang=js"

import "./PromotionsVue.vue?vue&type=style&index=0&id=2873a7f7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2873a7f7"]])

export default __exports__